import { useRef, useState, useCallback } from 'react';
import { useIntl } from 'react-intl-next';

import type { VersionHistoryNodeType } from '@confluence/version-history/entry-points/useVersionHistoryContentVersionHistoryQuery.ts';
import { getFormattedDate } from '@confluence/version-history/entry-points/versionHistoryUtils.ts';

export type DatabaseVersionHistoryTypes = {
	versionId: string | null;
	getVersionName: () => string | null;
	setDatabaseVersion: (version: VersionHistoryNodeType | null) => void;
};

export const useDatabaseVersionHistory = (): DatabaseVersionHistoryTypes => {
	const { formatDate, formatTime } = useIntl();

	const [databaseVersionId, setDatabaseVersionId] = useState<string | null>(null);
	const versionName = useRef<string | null>(null);

	const getVersionName = () => versionName.current;

	const setDatabaseVersion = useCallback(
		(version: VersionHistoryNodeType | null) => {
			setDatabaseVersionId(version?.contentProperties?.latest?.externalVersionId || null);
			versionName.current = version
				? getFormattedDate(version.updatedTime, formatDate, formatTime)
				: null;
		},
		[formatDate, formatTime],
	);

	return { versionId: databaseVersionId, getVersionName, setDatabaseVersion };
};
